/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_1Inputs */

const en_gc_search_guides_gridcraft_online_sections_2_steps_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use an .xlsx filename for a normal workbook, for example budget-online-test.xlsx. The browser build saves by downloading a file rather than updating a cloud document.`)
};

const zh_gc_search_guides_gridcraft_online_sections_2_steps_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`普通工作簿使用 .xlsx 文件名，例如 budget-online-test.xlsx。浏览器构建通过下载文件来保存，而不是更新云端文档。`)
};

/**
* | output |
* | --- |
* | "Use an .xlsx filename for a normal workbook, for example budget-online-test.xlsx. The browser build saves by downloading a file rather than updating a cloud ..." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_2_steps_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_2_Steps_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_2_steps_1(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_2_steps_1(inputs)
});
export { gc_search_guides_gridcraft_online_sections_2_steps_1 as "gc.search_guides.gridcraft_online.sections.2.steps.1" }